import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchStitchContReGrp } from '../../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchContReGrp } from '../../Selectors/StitchSelector/StitchingSelectors';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';


const StContReturnInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        stMemo: '',
        reMemo: '',
        empNm: '',
        itemNm: '',
        sono: '',
        soId: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        totQty: '',
        instruction: ''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const [material, setMaterial] = useState([]);
    const stitchlist = useSelector(selectStitchContReGrp);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchStitchContReGrp(Id));
    }, [Id, dispatch]);

    useEffect(() => {
        if (stitchlist.data && stitchlist.data.length > 0) {
            const item = stitchlist.data[0];
            const data = stitchlist.data;
            const penqty = parseFloat(item.totQty) - parseFloat(item.reQty);
            const penmat = parseFloat(item.totmat) - parseFloat(item.remat);

            setFormData(prev => ({
                ...prev,
                dt: data.map(item => item.dt).join(', '),
                stMemo: item.stMemo,
                reMemo: data.map(item => item.reMemo).join(','),
                totQty: item.totQty,
                instruction: item.instruction,
                empNm: item.empNm,
                itemNm: item.itemNm1 || item.itemNm,
                soId: item.soId,
                sono: item.sono,
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
                reqty: item.reQty,
                remat: item.remat,
                penmat: penmat,
                penqty: penqty,
                totmat: item.totmat,
                firmId: item?.firmId || ''
            }));
        }
        if (stitchlist?.Info2?.length > 0) {
            const values = stitchlist?.Info2;
            const sumqty = values?.reduce((acc, qty) => acc + parseFloat(qty.rqty), 0);
            setMaterial(values);
            setFormData(prev => ({
                ...prev,
                totmat2: sumqty
            }));
        }

    }, [stitchlist]);
    // console.log(stitchlist);
    const data = stitchlist?.Info?.length > 0 ? stitchlist.Info.flatMap(subArray => {
        return subArray.map(obj => obj);
    }) : [];
    // Reduce the data based on size
    const consolidatedArray = data.reduce((acc, curr) => {
        // Find if the size already exists in the accumulator
        const existing = acc.find(item => item.size === curr.size);

        if (existing) {
            // If it exists, sum up the values
            existing.rqty += Number(curr.rqty);
            existing.dqty += Number(curr.dqty);
            existing.rbqty += Number(curr.rbqty);
        } else {
            // If it doesn't exist, add it as a new object, converting numeric values to numbers
            acc.push({
                size: curr.size,
                issqty: curr.issqty,
                rqty: Number(curr.rqty),
                dqty: Number(curr.dqty),
                rbqty: Number(curr.rbqty)
            });
        }

        return acc;
    }, []);






    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Stitching Return Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>
                                    {formData.soId !== '0' &&
                                        <>
                                            <td style={{ width: '200px' }}>Sale Order No.</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>
                                        </>
                                    }
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Stitch Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.stMemo}</td>
                                    <td style={{ width: '200px' }}>Cutting Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reMemo}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totQty}</td>
                                    <td style={{ width: '200px' }}>Return Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reqty}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Pending Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', color: parseFloat(formData.penqty) > 0 ? 'red' : 'green' }} className='dark-color'>{formData.penqty}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Material Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totmat}</td>
                                    <td style={{ width: '200px' }}>Material Return Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.remat}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Pending Material Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', color: parseFloat(formData.penmat) > 0 ? 'red' : 'green' }} className='dark-color'>{formData.penmat}</td>

                                </tr>
                            </tbody>
                        </table>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth</td>
                                    <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>

                                </tr>

                                {formData.m1cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                    </tr>
                                }

                                {formData.m2cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                    </tr>
                                }

                                {formData.m3cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                    </tr>
                                }


                            </tbody>

                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>

                                    <td style={{ width: '200px' }}>Stitching Instructions</td>
                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>

                                </tr>
                            </tbody>
                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                        {consolidatedArray ? consolidatedArray.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.size}</TableCell>
                                        )) : null}
                                    </TableRow>


                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Qty.</TableCell>
                                        {consolidatedArray ? consolidatedArray.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.issqty}</TableCell>
                                        )) : null}
                                    </TableRow>

                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                        {consolidatedArray ? consolidatedArray.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.rqty}</TableCell>
                                        )) : null}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                        {consolidatedArray ? consolidatedArray.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000', color: 'red' }} align='center' key={index}>{val.dqty}</TableCell>
                                        )) : null}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>


                        {/* <table style={{ width: '80%', margin: '1% 5%' }}>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Material Work</th>
                                    <th>Qty</th>
                                </tr>
                            </thead>
                            <tbody>
                                {material.map((mat, matIndex) => (
                                    <>
                                        <tr key={matIndex}>
                                            <td>
                                                {matIndex + 1}
                                            </td>
                                            <td>
                                                {mat.materialNm}
                                            </td>
                                            <td>
                                                {mat.rqty}
                                            </td>


                                        </tr>
                                    </>
                                ))}
                                <tr>
                                    <td> </td>
                                    <td>
                                        <span className="tot-lump">Total Qty</span>
                                    </td>
                                    <td>
                                        <span className="tot-lump">{formData.totmat2}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default StContReturnInfo;
